import config from './config';
import { profile } from "../stores/storages/ProfileStorage";
import { clientInfo } from '../version'
import formatter from './formatter'
import api from './api'

const ContactService = {
  /**
   * -------------------- CALL API ----------------------
   */

  getProfile: async () => {
    const { token, username: msisdn } = profile.authAPI;
    const timestamp = new Date().getTime()
    const security = formatter.encrypt(`${msisdn}${token}${timestamp}`)

    const data = {
      params: {
        msisdn,
        timestamp,
        security,
      },
    }
    const options = null

    const res = await api.request({
      method: config.endpoints.contact.getProfile.method,
      path: config.endpoints.contact.getProfile.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  setProfile: async (name, gender, birthdayStr, birthday) => {
    const { token, username: msisdn } = profile.authAPI;
    const timestamp = new Date().getTime()
    const clientType = clientInfo.platform
    const revision = clientInfo.revision
    const info = {
      name,
      gender,
      birthdayStr,
      birthday,
    }
    const desktop = '1'
    const security = formatter.encrypt(`${msisdn}${JSON.stringify(info)}${clientType}${revision}${desktop}${token}${timestamp}`)
    const formData = new FormData()
    formData.set('msisdn', msisdn)
    formData.set('security', security)
    formData.set('clientType', clientType)
    formData.set('desktop', desktop)
    formData.set('revision', revision)
    formData.set('timestamp', timestamp)
    formData.set('info', JSON.stringify(info))
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
    const res = await api.request({
      method: config.endpoints.contact.setProfile.method,
      path: config.endpoints.contact.setProfile.path,
      host: config.host,
      data: formData,
      options,
    })
    return res
  },
  updateAvatar: async (image) => {
    const { token, username: msisdn } = profile.authAPI;
    const timestamp = new Date().getTime()
    const security = formatter.encrypt(`${msisdn}${token}${timestamp}`, true)
    const formData = new FormData()
    formData.append('msisdn', msisdn)
    formData.append('security', security)
    formData.append('timestamp', timestamp)
    formData.append('uploadfile', image)
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
    const res = await api.request({
      method: config.endpoints.contact.updateAvatarMobile.method,
      path: config.endpoints.contact.updateAvatarMobile.path,
      host: config.host,
      data: formData,
      options,
    })
    return res
  },
  getContacts: async () => {
    const { username: msisdn, token } = profile.authAPI;
    const contacts = '';
    const clientType = clientInfo.platform
    const revision = clientInfo.revision
    const version = clientInfo.version
    const timestamp = new Date().getTime()
    const security = formatter.encrypt(`${msisdn}${contacts}${clientType}${revision}${token}${timestamp}`)

    const data = {
      params: {
        msisdn,
        contacts,
        clientType,
        revision,
        version,
        timestamp,
        security,
      },
    }
    const options = null;

    const res = await api.request({
      method: config.endpoints.contact.getContacts.method,
      path: config.endpoints.contact.getContacts.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  addContacts: async (data, options) => {
    const res = await api.request({
      method: config.endpoints.contact.addContacts.method,
      path: config.endpoints.contact.addContacts.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  removeContacts: async (data, options) => {
    const res = await api.request({
      method: config.endpoints.contact.removeContacts.method,
      path: config.endpoints.contact.removeContacts.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  getNaNProfile: async (contact) => {
    if (contact) {
      const { token, username: msisdn } = profile.authAPI
      const timestamp = new Date().getTime()
      const security = formatter.encrypt(`${msisdn}${contact}${token}${timestamp}`)

      const data = {
        params: {
          msisdn,
          contact,
          timestamp,
          security,
        }
      }
      const options = null

      const res = await api.request({
        method: config.endpoints.contact.getNaNProfile.method,
        path: config.endpoints.contact.getNaNProfile.path,
        host: config.host,
        data,
        options,
      })
      return res
    }
    return new Promise(resolve => resolve(null))
  },
  getOfficialAccount: async (data, options) => {
    const res = await api.request({
      method: config.endpoints.contact.getOfficialAccount.method,
      path: config.endpoints.contact.getOfficialAccount.path,
      host: config.host,
      data,
      options,
    })
    return res
  },

  /**
   * -------------------- END CALL API ----------------------
   */
}

export default ContactService;